export const FilterIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Capa_1"
        viewBox="0 0 42.5 42.5"
        width={40}
        height={40}

    >
        <defs>
            <style>{".st0{fill:#006bc6}"}</style>
        </defs>
        <path
            d="M29 21.7c.3 0 .6 0 .9.2v-9.4c0-.5-.4-.9-.9-.9s-.9.4-.9.9v9.4c.3 0 .6-.2.9-.2ZM29 26.7c-.3 0-.6 0-.9-.2v3.6c0 .5.4.9.9.9s.9-.4.9-.9v-3.6c-.3 0-.6.2-.9.2Z"
            className="st0"
        />
        <path
            d="M29 27.4c-1.7 0-3.2-1.4-3.2-3.2S27.2 21 29 21s3.2 1.4 3.2 3.2-1.4 3.2-3.2 3.2Zm0-5c-1 0-1.8.8-1.8 1.8S28 26 29 26s1.8-.8 1.8-1.8-.8-1.8-1.8-1.8ZM21.3 17.2c-.3 0-.6 0-.9-.2v13.1c0 .5.4.9.9.9s.9-.4.9-.9V17c-.3 0-.6.2-.9.2Z"
            className="st0"
        />
        <path
            d="M21.3 17.9c-1.7 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2 3.2 1.4 3.2 3.2-1.4 3.2-3.2 3.2Zm0-5c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8ZM13.5 23.4c-.3 0-.6 0-.9-.2v6.9c0 .5.4.9.9.9s.9-.4.9-.9v-6.9c-.3 0-.6.2-.9.2ZM13.5 18.4c.3 0 .6 0 .9.2v-6.1c0-.5-.4-.9-.9-.9s-.9.4-.9.9v6.1c.3 0 .6-.2.9-.2Z"
            className="st0"
        />
        <path
            d="M13.5 24c-1.7 0-3.2-1.4-3.2-3.2s1.4-3.2 3.2-3.2 3.2 1.4 3.2 3.2-1.4 3.2-3.2 3.2Zm0-4.9c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8 1.8-.8 1.8-1.8-.8-1.8-1.8-1.8Z"
            className="st0"
        />
    </svg>
);